import TransportsUtil from './transports-util';

export default class Warning {
    constructor(type, time, critical, message, latlng) {
        this.type = type; // temp / door
        this.time = time;
        this.critical = critical; // Critical == HACCP no longer compliant
        this.message = message;
        this.latlng = latlng;
    }

    typeString() {
        if (this.type === 'temp') {
            return 'TRANSPORTS.TEMP';
        } else if (this.type === 'door') {
            return 'TRANSPORTS.DOOR';
        }
        return '-';
    }

    timeLocal() {
        return TransportsUtil.unixToLocalTime(this.time);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/transports/Warning.js